import { h } from "preact";
import { useState } from "preact/hooks";


export default function AcheterViteUnBien() {

	return (<div>Acheter vite un bien</div>)
}